import { Injectable } from '@angular/core';
import { WindowService } from './window.service';

interface ParamType {
  src?: string;
  id?: string;
  script?: string;
}

@Injectable()
export class ScriptExternoService {

  constructor(private win: WindowService) { }

  gerarScript(configuracao: ParamType): string {
    const { src, id } = configuracao;
    const body = this.win.nativeDocument.body;
    const tag = this.win.nativeDocument.createElement('script');
    tag.async = true;
    tag.id = id || `_${src.match(/[^_\W]+/g).join('')}`;
    tag.src = src;
    body.insertBefore(tag, body.firstChild);
    return tag.id;
  }

  removerScript(id: string): void {
    const script = this.win.nativeDocument.getElementById(id);
    if (script) {
      script.parentNode.removeChild(script);
    }
  }
}
